import styled, { css } from "styled-components";

export const SelectableCardGroupRoot = styled.div(
    () => css`
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        width: 100%;
        gap: 15px;
    `,
);
